import { GET_CUSTOMER_FAILED, GET_CUSTOMER_REQUESTED, GET_CUSTOMER_SUCCESS, GET_MATRIXCUSTOMER_FAILED, GET_MATRIXCUSTOMER_REQUESTED, GET_MATRIXCUSTOMER_SUCCESS, GET_TICKETCUSTOMER_FAILED, GET_TICKETCUSTOMER_REQUESTED, GET_TICKETCUSTOMER_SUCCESS, UPDATE_CUSTOMER_FAILED, UPDATE_CUSTOMER_REQUESTED, UPDATE_CUSTOMER_SUCCESS } from "resources/actionTypes";


const initialState = {
  userCustomer: [],
  loading: false,
  error: null,
};

const initialStateMatrix = {
  userMatrixCustomer: [],
  loading: false,
  error: null,
}

const initialStateTicket = {
  userTicketCustomer: [],
  loading: false,
  error: null,
}
const initialStateUpdate = {
  userUpdateCustomer: [],
  loading: false,
  error: null
}

export function userCustomer(state = initialState, action) {
  switch (action.type) {
    case GET_CUSTOMER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        userCustomer: action.userCustomer,
      };
    case GET_CUSTOMER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userMatrixCustomer(state =
  initialStateMatrix, action) {
  switch (action.type) {
    case GET_MATRIXCUSTOMER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_MATRIXCUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        userMatrixCustomer: action.userMatrixCustomer
      };
    case GET_MATRIXCUSTOMER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userTicketCustomer(state =
  initialStateTicket, action) {
  switch (action.type) {
    case GET_TICKETCUSTOMER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_TICKETCUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        userTicketCustomer: action.userTicketCustomer
      };
    case GET_TICKETCUSTOMER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userUpdateCustomer(state = initialStateUpdate, action) {
  switch (action.type) {
    case UPDATE_CUSTOMER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        userUpdateCustomer: action.userUpdateCustomer,
      };
    case UPDATE_CUSTOMER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
